import React, { useState, useContext, useEffect, memo } from "react";
// MODULOS
import Draggable from "react-draggable";

// FUNCIONES
import { replaceCaracteres, trimPropsItem } from "../../../../config/const";

// AXIOS
import clienteAxios from "../../../../config/axios";
// CONTEXT
import AlertaContext from "../../../../Context/Alerta/AlertaContext";
import AuthContext from "../../../../Context/Auth/AuthContext";

import ModalPersona from "../../../Compras/Proveedores/Personas_ISP/Componentes/Modal";
// MATERIAL
import {
  Modal,
  Box,
  Button,
  Divider,
  Typography,
  IconButton,
  TextField,
  FormControl,
  Autocomplete,
  Tooltip,
  MenuItem,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  useTheme,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputAdornment,
} from "@mui/material";
import { Check, Close, Save } from "@mui/icons-material";
import { useModalStyle } from "../../../../styles/styleModal";
import { objectDefault, validacion } from "../data";
import { useSimpleTable } from "../../../../hooks/useSimpleTable";
import ConfirmacionDialog from "../../../components/Dialogs/ConfirmacionDialog";
import { useDraggable } from "../../../../hooks/useDraggable";
import ListDatoLab from "./ListDatoLab";
import CampoDoc from "../../../components/Campos/CampoDoc";
// import useMultimediasUpload from "../../../../hooks/useMultimediasUpload";
const seccionDefault = "DATOS PRINCIPALES";
const subseccionDefault = "quimica_sanguinea";
const ModalAnticipos = (props) => {
  //props
  const {
    editar,
    seteditar,
    setopen,
    open,
    ObjectoActivo,
    changeObjetoActivoState,
    socket,
  } = props;
  const [item, setitem] = useState(ObjectoActivo);
  const [veterinariosData, setveterinariosData] = useState([]);
  const {} = item;
  // const {
  //   setmodificoImagenes,
  //   subirImagenes,
  //   imagenes,
  //   setimagenes,
  // } = useMultimediasUpload("laboratorio_clinico");
  const { mostrarAlerta } = useContext(AlertaContext);
  const { usuario } = useContext(AuthContext);

  // SECCION

  const [seccionActive, setseccionActive] = useState(seccionDefault);
  const [subseccionActive, setsubseccionActive] = useState(subseccionDefault);
  const [clientesData, setclientesData] = useState([]);
  const [mascotasData, setmascotasData] = useState([]);
  // DE SIEMPRE
  const [cargando, setcargando] = useState(false);
  const [error, seterror] = useState({});
  const clases = useModalStyle();

  useEffect(() => {
    // const getequipoData = async () => {
    //   try {
    //     const resequipoData = await clienteAxios("/maquinarias/filtro/0");
    //     setequipoData(resequipoData.data.data);
    //   } catch (error) {
    //     setequipoData([]);
    //   }
    // };
    // if (!equipoData) {
    //   getequipoData();
    // }
    console.log(ObjectoActivo);

    setitem(ObjectoActivo);

    // eslint-disable-next-line
  }, [ObjectoActivo]);

  const [quimica_sanguineaData, setquimica_sanguineaData] = useState(null);
  const [hemostasia_coagulacionData, sethemostasia_coagulacionData] = useState(
    null
  );
  const [hematologiaData, sethematologiaData] = useState(null);
  const [paneles_bioquimicaData, setpaneles_bioquimicaData] = useState(null);

  const getquimica_sanguineaData = async () => {
    try {
      const resquimica_sanguineaData = await clienteAxios.get(
        `/quimica_sanguinea/todo`
      );

      console.log(resquimica_sanguineaData);

      setquimica_sanguineaData(resquimica_sanguineaData.data);
    } catch (error) {
      setquimica_sanguineaData([]);
    }
  };
  const gethematologiaData = async () => {
    try {
      const reshematologiaData = await clienteAxios.get(`/hematologia/todo`);
      console.log(reshematologiaData);

      sethematologiaData(reshematologiaData.data);
    } catch (error) {
      sethematologiaData([]);
    }
  };

  const gethemostasia_coagulacionData = async () => {
    try {
      const reshemostasia_coagulacionData = await clienteAxios.get(
        `/hemostasia_coagulacion/todo`
      );

      console.log(reshemostasia_coagulacionData);

      sethemostasia_coagulacionData(reshemostasia_coagulacionData.data);
    } catch (error) {
      sethemostasia_coagulacionData([]);
    }
  };
  const getpaneles_bioquimicaData = async () => {
    try {
      const respaneles_bioquimicaData = await clienteAxios.get(
        `/paneles_bioquimica/todo`
      );

      console.log(respaneles_bioquimicaData);

      setpaneles_bioquimicaData(respaneles_bioquimicaData.data);
    } catch (error) {
      setpaneles_bioquimicaData([]);
    }
  };

  useEffect(() => {
    if (!quimica_sanguineaData) {
      getquimica_sanguineaData();
    }
    if (!hemostasia_coagulacionData) {
      gethemostasia_coagulacionData();
    }
    if (!hematologiaData) {
      gethematologiaData();
    }
    if (!paneles_bioquimicaData) {
      getpaneles_bioquimicaData();
    }
  }, []);

  const defaultActive = () => {
    changeObjetoActivoState(objectDefault);
    setitem(objectDefault);
    setopen(false);
    seteditar(false);
    seterror({});
    setcargando(false);
    setseccionActive(seccionDefault);
    // setimagenes([]);
  };
  const handleChange = (e) => {
    const res = replaceCaracteres(e.target.value);
    setitem({
      ...item,
      [e.target.name]: res,
    });
  };

  const handleCrear = async () => {
    try {
      if (validacion(item, setitem, seterror)) {
        return mostrarAlerta("Faltan campos obligatorios", "error");
      }
      setcargando(true);
      console.log(
        trimPropsItem({
          ...item,

          // actaFotos: resDocumentos,
          tabla: "laboratorio_clinico",
          rucempresa: usuario.rucempresa,
          rol: usuario.rol,
          lc_usuario: usuario.usuario,
          lc_empresa: usuario.rucempresa,
        })
      );

      socket.current.emit(
        "client:guardarData",
        trimPropsItem({
          ...item,

          // actaFotos: resDocumentos,
          tabla: "laboratorio_clinico",
          rucempresa: usuario.rucempresa,
          rol: usuario.rol,
          lc_usuario: usuario.usuario,
          lc_empresa: usuario.rucempresa,
        })
      );
      setcargando(false);
      return defaultActive();
    } catch (error) {
      setcargando(false);
      mostrarAlerta("Hubo un error", "error");
      return defaultActive();
    }
  };
  const handleEditar = async () => {
    try {
      if (validacion(item, setitem, seterror)) {
        return mostrarAlerta("Faltan campos obligatorios", "error");
      }
      setcargando(true);

      socket.current.emit(
        "client:actualizarData",
        trimPropsItem({
          ...item,
          // actaFotos: resDocumentos,
          tabla: "laboratorio_clinico",
          rucempresa: usuario.rucempresa,
          rol: usuario.rol,
          lc_usuario: usuario.usuario,
          lc_empresa: usuario.rucempresa,
        })
      );
      setcargando(false);
      return defaultActive();
    } catch (error) {
      setcargando(false);
      mostrarAlerta("Hubo un error", "error");
      return defaultActive();
    }
  };
  const handleGuardar = () => {
    if (editar) {
      handleEditar();
    } else {
      handleCrear();
    }
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        <Draggable handle="#handle">
          <Box display="flex" justifyContent="center">
            <div
              style={{
                borderRadius: "15px",
                position: "absolute",
                overflow: "scroll",
                maxHeight: "95vh",
              }}
              className={clases.paper}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                width="100%"
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  width="100%"
                >
                  <Typography
                    style={{ cursor: "-webkit-grab" }}
                    id="handle"
                    variant="button"
                    color="initial"
                    align="center"
                  >
                    {`${editar ? "Editar" : "Agregar"} Registro Clinico.`}
                  </Typography>
                  <Tooltip title={"Guardar"} followCursor placement="top-start">
                    <IconButton
                      onClick={() => {
                        if (validacion(item, setitem, seterror)) {
                          return mostrarAlerta(
                            "Faltan campos obligatorios",
                            "error"
                          );
                        }

                        handleGuardar();
                      }}
                    >
                      <Save color="secondary" />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box display={"flex"} alignItems={"center"}>
                  <IconButton
                    onClick={() => {
                      defaultActive();
                    }}
                  >
                    <Close color={"error"} />
                  </IconButton>
                </Box>
              </Box>
              <Divider />
              <Box display="flex" justifyContent="space-between" width="100%">
                <Box display={"flex"} flexWrap={"wrap"}>
                  <Button
                    variant={
                      seccionActive === "DATOS PRINCIPALES"
                        ? "contained"
                        : error.actaDocCliente
                        ? "outlined"
                        : "null"
                    }
                    color={error.actaDocCliente ? "error" : "primary"}
                    disableElevation
                    className={clases.buttonTab}
                    size="small"
                    onClick={() => setseccionActive("DATOS PRINCIPALES")}
                  >
                    DATOS PRINCIPALES
                  </Button>
                </Box>
              </Box>
              <Divider />
              <Box className={clases.container}>
                {seccionActive === "DATOS PRINCIPALES" && (
                  <>
                    <TextField
                      type="date"
                      className={clases.formD}
                      label="Fecha"
                      value={item.lc_fecha}
                      name="lc_fecha"
                      error={error.lc_fecha}
                      onChange={handleChange}
                    />
                    <FormControl fullWidth className={clases.formD}>
                      <Autocomplete
                        filterOptions={(x) => x}
                        options={mascotasData.map((item) => {
                          return (
                            item.mascNombre +
                            "/+/" +
                            item.mascPerNombre +
                            "/+/" +
                            item.mascId
                          );
                        })}
                        getOptionLabel={(option) => {
                          return option.replace("/+/", " - ").split("/+/")[0];
                        }}
                        id="controlled-demo"
                        value={item.lc_nombre_mascota}
                        paperprops
                        onChange={async (event, newValue) => {
                          if (newValue) {
                            const options = newValue.split("/+/");
                            console.log(options, mascotasData);

                            const itemF = mascotasData.find((itemMascota) => {
                              return (
                                String(itemMascota.mascId) ===
                                String(options[2])
                              );
                            });
                            console.log(itemF);

                            console.log({
                              ...item,
                              // --- Mascota ---
                              lc_id_mascota: itemF.mascId,
                              lc_nombre_mascota: itemF.mascNombre,
                              lc_raza_mascota: itemF.mascRaza,
                              lc_especie_mascota: itemF.mascEspecie,
                              lc_sexo_mascota: itemF.mascSexo,
                              lc_edad_mascota: itemF.mascEdad,

                              // --- Propietario ---
                              lc_id_propietario: itemF.mascPerId,
                              lc_nombre_propietario: itemF.mascPerNombre,
                              lc_email_propietario: itemF.mascPerEmail,
                            });

                            setitem({
                              ...item,
                              // --- Mascota ---
                              lc_id_mascota: itemF.mascId,
                              lc_nombre_mascota: itemF.mascNombre,
                              lc_raza_mascota: itemF.mascRaza,
                              lc_especie_mascota: itemF.mascEspecie,
                              lc_sexo_mascota: itemF.mascSexo,
                              lc_edad_mascota: itemF.mascEdad,

                              // --- Propietario ---
                              lc_id_propietario: itemF.mascPerId,
                              lc_nombre_propietario: itemF.mascPerNombre,
                              lc_email_propietario: itemF.mascPerEmail,
                            });
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={error.lc_nombre_mascota}
                            label="Paciente"
                            fullWidth
                            onChange={async (e) => {
                              if (e.target.value === "") {
                                return;
                              }
                              try {
                                const res = await clienteAxios.get(
                                  `/mascotas/filtro/0?search=${e.target.value}`
                                );
                                if (!res.data.data) {
                                  return mostrarAlerta(res.data.msg, "error");
                                }

                                setmascotasData(res.data.data);
                              } catch (error) {}
                            }}
                          />
                        )}
                      />
                    </FormControl>
                    <TextField
                      disabled
                      className={clases.formD}
                      label="Raza"
                      value={item.lc_raza_mascota}
                      name="lc_raza_mascota"
                      error={error.lc_raza_mascota}
                      onChange={handleChange}
                    />
                    <TextField
                      disabled
                      className={clases.formD}
                      label="Edad"
                      value={item.lc_edad_mascota}
                      name="lc_edad_mascota"
                      error={error.lc_edad_mascota}
                      onChange={handleChange}
                    />
                    <TextField
                      disabled
                      className={clases.formD}
                      label="Sexo"
                      value={item.lc_sexo_mascota}
                      name="lc_sexo_mascota"
                      error={error.lc_sexo_mascota}
                      onChange={handleChange}
                    />
                    <TextField
                      disabled
                      className={clases.formD}
                      label="Propietario"
                      value={item.lc_nombre_propietario}
                      name="lc_nombre_propietario"
                      error={error.lc_nombre_propietario}
                      onChange={handleChange}
                    />
                    <FormControl fullWidth className={clases.formD}>
                      <Autocomplete
                        filterOptions={(x) => x}
                        options={veterinariosData.map((item) => {
                          return item.perNombre + "/+/" + item.perId;
                        })}
                        getOptionLabel={(option) => {
                          return option.split("/+/")[0];
                        }}
                        id="controlled-demo"
                        value={item.lc_nombre_medico}
                        paperprops
                        onChange={async (event, newValue) => {
                          if (newValue) {
                            const options = newValue.split("/+/");
                            const itemF = veterinariosData.find(
                              (itemPersona) => {
                                return itemPersona.perId === Number(options[1]);
                              }
                            );

                            setitem({
                              ...item,
                              lc_nombre_medico: itemF.perNombre,
                              lc_id_medico: itemF.perId,
                            });
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            error={error.lc_nombre_medico}
                            label="Medico"
                            fullWidth
                            onChange={async (e) => {
                              if (e.target.value === "") {
                                return;
                              }
                              try {
                                const res = await clienteAxios.get(
                                  `/proveedores/filtro/0?search=${e.target.value}&estado=VETERINARIO`
                                );
                                console.log({ res });

                                if (!res.data.data) {
                                  return mostrarAlerta(res.data.msg, "error");
                                }
                                setveterinariosData(res.data.data);
                              } catch (error) {}
                            }}
                            // InputProps={{
                            //   ...params.InputProps,
                            //   endAdornment: (
                            //     <React.Fragment>
                            //       {!editar ? (
                            //         <IconButton
                            //           size="small"
                            //           aria-label=""
                            //           onClick={async () => {
                            //             seteditarProveedor(false);
                            //             setopenProveedor(true);
                            //           }}
                            //         >
                            //           <AddCircleOutlineTwoTone color="primary" />
                            //         </IconButton>
                            //       ) : null}
                            //       {params.InputProps.endAdornment}
                            //     </React.Fragment>
                            //   ),
                            // }}
                          />
                        )}
                      />
                    </FormControl>
                    <CampoDoc
                      size="medium"
                      error={error}
                      extension="PDF"
                      disabledE={cargando}
                      disabled={cargando}
                      setcargando={setcargando}
                      label={"Documento"}
                      propiedad={"lc_archivo"}
                      item={item}
                      setitem={setitem}
                      celda={false}
                    />
                    <TextField
                      multiline
                      rows={2}
                      variant="outlined"
                      className={clases.formAllW}
                      label="Observación"
                      value={item.lc_observacion}
                      name="lc_observacion"
                      error={error.lc_observacion}
                      onChange={handleChange}
                    />
                    {/* <FormControl fullWidth className={clases.formD}>
                      <Autocomplete
                        filterOptions={(x) => x}
                        options={clientesData.map((item) => {
                          return (
                            item.perDocNumero +
                            "/+/" +
                            item.perNombre +
                            "/+/" +
                            item.perDocTipo
                          );
                        })}
                        getOptionLabel={(option) => {
                          return option.replace("/+/", " ").replace("/+/", " ");
                        }}
                        id="controlled-demo"
                        value={
                          (actaDocCliente + " " + actaNombreCliente).trim() ===
                          ""
                            ? ""
                            : actaDocCliente + " " + actaNombreCliente
                        }
                        paperprops
                        onChange={async (event, newValue) => {
                          if (newValue) {
                            const options = newValue.split("/+/");

                            const findItem = clientesData.find(
                              (clienteData) =>
                                clienteData.perDocNumero === options[0]
                            );

                            setitem({
                              ...item,
                              actaIdCliente: findItem.perId,
                              actaDocCliente: findItem.perDocNumero,
                              actaNombreCliente: findItem.perNombre,
                              actaDireccionCliente: findItem.perDireccion,
                              actaTelCliente: findItem.perCelular,
                              actaEmailCliente: findItem.perEmail,
                              actaCiudad: findItem.ciudad,
                              actaSector: findItem.sector
                                ? [findItem.sector]
                                : [findItem.sector],
                            });
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            required
                            label={"Cliente"}
                            fullWidth
                            error={error.actaDocCliente}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  <IconButton
                                    size="small"
                                    aria-label=""
                                    onClick={async () => {
                                      // seteditarProveedor(false);
                                      setOpenPersona(true);
                                    }}
                                  >
                                    <AddCircleOutlineTwoTone color="primary" />
                                  </IconButton>

                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                            onChange={async (e) => {
                              if (e.target.value === "") {
                                return mostrarAlerta(
                                  "Ingrese un documento",
                                  "error"
                                );
                              }
                              try {
                                const res = await clienteAxios.get(
                                  `/proveedores/agregarperfil/0?search=${e.target.value}`
                                );
                                if (!res.data.data) {
                                  return mostrarAlerta(res?.data?.msg, "error");
                                }

                                setclientesData(res.data.data);
                              } catch (error) {}
                            }}
                          />
                        )}
                      />
                    </FormControl>
                    <TextField
                      disabled
                      label="Dirección Cliente"
                      error={error.actaDireccionCliente}
                      value={actaDireccionCliente}
                      name="actaDireccionCliente"
                      onChange={(e) => handleChange(e)}
                      className={clases.formD}
                      size="small"
                    /> */}
                  </>
                )}

                <Box display="flex" justifyContent="space-between" width="100%">
                  <Box display={"flex"} flexWrap={"wrap"}>
                    {[
                      "quimica_sanguinea",
                      "hematologia",
                      "hemostasia_coagulacion",
                      "paneles_bioquimica",
                    ].map((item) => (
                      <Button
                        variant={
                          subseccionActive === item
                            ? "contained"
                            : error.actaDocCliente
                            ? "outlined"
                            : "null"
                        }
                        color={error.actaDocCliente ? "error" : "secondary"}
                        disableElevation
                        className={clases.buttonTab}
                        size="small"
                        onClick={() => setsubseccionActive(item)}
                      >
                        {item.replace("_", " ")}
                      </Button>
                    ))}
                  </Box>
                </Box>
                {subseccionActive === "quimica_sanguinea" && (
                  <ListDatoLab
                    readOnly={false}
                    error={error}
                    item={item}
                    setitem={(e) => {
                      setitem(e);
                    }}
                    data={quimica_sanguineaData}
                    propiedad={item.lc_quimica_sanguinea}
                    propiedadString={"lc_quimica_sanguinea"}
                    propiedadId={"qs_id"}
                    propiedadMostrar1={"qs_categoria"}
                    propiedadMostrar2={"qs_parametro"}
                  />
                )}
                {subseccionActive === "hematologia" && (
                  <ListDatoLab
                    readOnly={false}
                    error={error}
                    item={item}
                    setitem={(e) => {
                      setitem(e);
                    }}
                    data={hematologiaData}
                    propiedad={item.lc_hematologia}
                    propiedadString={"lc_hematologia"}
                    propiedadId={"h_id"}
                    propiedadMostrar1={"h_parametro"}
                    propiedadMostrar2={"qs_parametro"} //h_categoria
                  />
                )}

                {subseccionActive === "hemostasia_coagulacion" && (
                  <ListDatoLab
                    readOnly={false}
                    error={error}
                    item={item}
                    setitem={(e) => {
                      setitem(e);
                    }}
                    data={hemostasia_coagulacionData}
                    propiedad={item.lc_hemostasia_coagulacion}
                    propiedadString={"lc_hemostasia_coagulacion"}
                    propiedadId={"hc_id"}
                    propiedadMostrar1={"hc_parametro"}
                    propiedadMostrar2={"hc_categoria"}
                  />
                )}
                {subseccionActive === "paneles_bioquimica" && (
                  <ListDatoLab
                    readOnly={false}
                    error={error}
                    item={item}
                    setitem={(e) => {
                      setitem(e);
                    }}
                    data={paneles_bioquimicaData}
                    propiedad={item.lc_paneles_bioquimica}
                    propiedadString={"lc_paneles_bioquimica"}
                    propiedadId={"pb_id"}
                    propiedadMostrar1={"pb_categoria"}
                    propiedadMostrar2={"pb_parametro"}
                  />
                )}
              </Box>

              <Divider />
              <Box display="flex" width="100%" justifyContent="space-between">
                <Box width="100%" display="flex" justifyContent="flex-end">
                  <Button
                    style={{ width: "30%" }}
                    variant="contained"
                    color="primary"
                    disabled={cargando}
                    onClick={() => {
                      if (validacion(item, setitem, seterror)) {
                        return mostrarAlerta(
                          "Faltan campos obligatorios",
                          "error"
                        );
                      }

                      handleGuardar();
                    }}
                  >
                    Guardar
                  </Button>
                </Box>
              </Box>
            </div>
          </Box>
        </Draggable>
      </Box>
    </Modal>
  );
};

export default memo(ModalAnticipos);
